/* eslint-disable @typescript-eslint/indent */
export const required = (value: any) => (value ? undefined : 'Required')

export const mustBeNumber = (value: any) =>
  isNaN(value) ? 'Must be a number' : undefined

export const minValue = (min: number) => (value: any) =>
  isNaN(value) || value >= min ? undefined : `Should be greater than ${min}`

export const isValidDate = (input: any) => {
  if (typeof input !== 'string') return 'Invalid date format, please use DD.MM.YYYY'

  const datePattern = /^(\d{2})\.(\d{2})\.(\d{4})$/
  const match = input.match(datePattern)

  if (!match) return 'Invalid date format, please use DD.MM.YYYY'

  const day = parseInt(match[1], 10)
  const month = parseInt(match[2], 10)
  const year = parseInt(match[3], 10)
  const date = new Date(year, month - 1, day)

  if (
    date.getDate() === day &&
    date.getMonth() === month - 1 &&
    date.getFullYear() === year
  ) {
    return undefined
  }

  return 'Invalid date format, please use DD.MM.YYYY'
}

export const composeValidators =
  (...validators: any[]) =>
  (value: any) =>
    validators?.reduce(
      (error: any, validator: any) => error || validator(value),
      undefined
    )
